import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {toString, toList} from "../../helpers/helpers";
import {map} from "rxjs/operators";
import {WorkflowStepGqlModel} from "../models/workflow.gql-model";

export class WorkflowNotificationUser {
  name: string;
  emailAddress: string;
  roles: string[];

  constructor(json?: any) {
    json = json || {};

    this.name = toString(json.name);
    this.emailAddress = toString(json.emailAddress);
    this.roles = toList(toString, json.roles);
  }
}

@Injectable({providedIn: "root"})
export class WorkflowNotificationService {
  constructor(private http: HttpClient) {}

  getUsers(targetStep: WorkflowStepGqlModel): Promise<WorkflowNotificationUser[]> {
    const params = {
      workflowId: toString(targetStep.workflowId),
      stepName: toString(targetStep.stepName),
    };

    return this.http.get<{users: WorkflowNotificationUser[]}>("/api/workflow/users", {params})
      .pipe(map(json => toList(obj => new WorkflowNotificationUser(obj), json["users"])))
      .toPromise();
  }

  sendNotification(targetStep: WorkflowStepGqlModel): Promise<any> {
    return this.http.post("/api/workflow/notify", {workflowId: targetStep.workflowId, stepName: targetStep.stepName})
      .toPromise();
  }
}
